import { VirtualTournament } from '../types';

export function findVirtualTournamentByTournamentId(
    virtualTournaments: VirtualTournament[],
    id: number,
): VirtualTournament | undefined {
    return virtualTournaments.find(tournament => tournament.tournamentId === id);
}

export function findVirtualTournamentByChildId(
    virtualTournaments: VirtualTournament[],
    id: number,
): VirtualTournament | undefined {
    return virtualTournaments.find(tournament =>
        tournament.childrenIds.includes(id),
    );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/competitions/utilities/virtualTournamentsUtilities.ts